var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSampling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .sampling-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1_00000048462942443305955390000006307985646333201830_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 186,
    className: "sampling-st0",
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "sampling-st0",
    d: "M132.1,16.6V305c0,21.6,16.6,39,37.1,39c20.6,0,37.1-17.4,37.1-39V48.8c0-25.3,21.6-32.7,21.6-32.7 C192.9,16,151.7,16,132.1,16.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampling);
export default __webpack_public_path__ + "static/media/sampling.a1851d093c12c847d2adb556b552e9f2.svg";
export { ForwardRef as ReactComponent };